import { render, staticRenderFns } from "./SplaReport.vue?vue&type=template&id=3749f972&"
import script from "./SplaReport.vue?vue&type=script&lang=js&"
export * from "./SplaReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports